/* eslint-disable max-len */
import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import { Box } from '@material-ui/core';
import axios, { API } from 'config/axios';
import ReviewsTitle from 'common/components/ReviewsTitle';
import ReviewCard from 'common/components/ReviewCard';
import { withTranslation } from 'config/i18n';
import { useRouter } from 'next/router';
import ERPagination from 'components/ERPagination';
import useHandleResponse from 'utils/useHandleResponse';
import {
  useLayoutState,
} from 'components/shared/Layout';

dayjs.extend(advancedFormat);
const REVIEWS_PER_PAGE = 10;

const Reviews = (props) => {
  const {
    t, rate, reivewsSSRData, isLgWider, SectionDividerComp,
  } = props;
  const router = useRouter();
  const { layoutState } = useLayoutState();
  const { handleError } = useHandleResponse();
  const [page, setPage] = useState(1);
  const [response, setResponse] = useState(reivewsSSRData || {});
  const { data: reviews } = response;
  const getReviewsData = (pageNumber) => {
    axios
      .get(API.vehicles.reviews.replace('{id}', router.query.id), {
        params: {
          current_page: pageNumber,
          per_page: REVIEWS_PER_PAGE,
        },
      })
      .then(({ data }) => {
        setResponse(data);
      })
      .catch((err) => {
        try {
          switch (err.response.status) {
            case 404:
              setResponse({ data: [] });
              break;
            default:
              handleError(err, false);
          }
        } catch (error) {
          handleError(error, false);
        }
      });
  };
  const handleChange = (value) => {
    setPage(value);
    getReviewsData(value);
  };
  useEffect(() => {
    if (process.browser && !layoutState.isCrawler) {
      getReviewsData(1);
    }
  }, []);
  return (!!response?.pagination?.total_count) && (
    <>
      {isLgWider && SectionDividerComp}
      <Box mb={2.25}>
        <ReviewsTitle
          title={t('fe_es_vehicle_page:reviews_from_riders')}
          rateAvg={rate}
          reviewsCount={response.pagination?.total_count}
        />
      </Box>

      <Box>
        {reviews?.map((review) => (
          <ReviewCard
            key={review.added_at}
            userImage={review.user.avatar_url}
            userName={review.user.name}
            // verified /// check this prop if needed
            reviewDate={dayjs(review.added_at).format('MMMM Do YYYY, h:mm:ss a')}
            rate={review.rating}
            bikeName="" // later
            bikeHref="" // later
            reviewDetails={[
              {
                subject: 'Bike',
                // title: 'Verty good bike', // no title
                description: review.bike_review,
                // rating: 3, // already provided
              },
              {
                subject: 'Host',
                // title: 'Verty good Host',
                description: review.host_review,
                // rating: 4,
              },
            ]}
          />
        ))}
      </Box>
      <Box mt={4}>
        <ERPagination
          data={{
            pages_count: Math.ceil(
              response.pagination ? response.pagination.total_count / REVIEWS_PER_PAGE : 0,
            ),
            active_page: page,
          }}
          handleChange={handleChange}
        />
      </Box>
    </>
  );
};

export default withTranslation('fe_es_vehicle_page')(Reviews);
